import PageHome from '../pages/PageHome';
import PageSearchPreview from "../pages/search/PageSearchPreview.vue";
import PageSearch from "../pages/search/PageSearch.vue";
import i18n from "../i18n";
import PageInformation from "../pages/PageInformation.vue";
import PageAbout from "../pages/PageAbout.vue";
import PageEvents from "../pages/PageEvents.vue";
import PageVideos from "../pages/PageVideos.vue";
import PageVideo from "../pages/PageVideo.vue";
import PageArtists from "../pages/PageArtists.vue";
import PageArtist from "../pages/PageArtist.vue";
import PagePartners from "../pages/PagePartners.vue";
import PageEvent from "../pages/PageEvent.vue";
import PageProject from "../pages/PageProject.vue";
import PageAnarchiveChrono from "../pages/PageAnarchiveChrono.vue";
import PageProjects from "../pages/PageProjects.vue";
import PageAnarchive from "../pages/PageAnarchive.vue";
import PageAnarchiveGrid from "../pages/PageAnarchiveGrid.vue";
import PageFolder from "../pages/PageFolder.vue";
import PageFolders from "../pages/PageFolders.vue";
import PageAnarchiveGridV2 from "../pages/PageAnarchiveGridV2.vue";

export default [
    {
        path: '/',
        name: 'home',
        component: PageHome,
        props: true,
        meta: { title: i18n.t('pages.home'), resetScrollbar: true, }
    },
    {
        path: '/information',
        name: 'information',
        component: PageInformation,
        props: true,
        meta: { title: i18n.t('pages.information'), resetScrollbar: true, }
    },
    {
        path: '/search-preview',
        name: 'search-preview',
        component: PageSearchPreview,
        props: true,
        meta: { title: i18n.t('pages.search'), resetScrollbar: true, }
    },
    {
        path: '/search',
        name: 'search',
        component: PageSearch,
        props: true,
        meta: { title: i18n.t('pages.search'), resetScrollbar: true, }
    },
    {
        path: '/about',
        name: 'about',
        component: PageAbout,
        props: true,
        meta: { title: i18n.t('pages.about'), resetScrollbar: true, }
    },
    {
        path: '/events',
        name: 'event.index',
        component: PageEvents,
        props: true,
        meta: { title: i18n.t('pages.events'), resetScrollbar: true, }
    },
    {
        path: '/events/:id/:slug?',
        name: 'event.view',
        component: PageEvent,
        props: true,
        meta: { title: i18n.t('pages.event'), resetScrollbar: true }
    },
    {
        path: '/anarchive',
        name: 'anarchive',
        component: PageAnarchive,
        redirect: {name: 'anarchive.grid'},
        props: true,
        children: [
            {
                path: '',
                component: PageAnarchiveGridV2,
                name: 'anarchive.grid',
                meta: { title: i18n.t('pages.anarchive'), resetScrollbar: true }
            },
            {
                path: 'chrono',
                component: PageAnarchiveChrono,
                name: 'anarchive.chrono',
                meta: { title: i18n.t('pages.anarchive'), resetScrollbar: true }
            },
        ],
    },
    {
        path: '/videos',
        name: 'video.index',
        component: PageVideos,
        props: true,
        meta: { title: i18n.t('pages.videos'), resetScrollbar: true, }
    },
    {
        path: '/videos/:id/:slug?',
        name: 'video.view',
        component: PageVideo,
        props: true,
        meta: { title: i18n.t('pages.video'), resetScrollbar: true, }
    },
    {
        path: '/people',
        name: 'people.index',
        component: PageArtists,
        props: true,
        meta: { title: i18n.t('pages.peoples'), resetScrollbar: true, }
    },
    {
        path: '/people/:id/:slug?',
        name: 'people.view',
        component: PageArtist,
        props: true,
        meta: { title: i18n.t('pages.people'), resetScrollbar: true, }
    },
    {
        path: '/partners',
        name: 'partners',
        component: PagePartners,
        props: true,
        meta: { title: i18n.t('pages.partners'), resetScrollbar: true, }
    },
    {
        path: '/projects/:id/:slug?',
        name: 'project.view',
        component: PageProject,
        props: true,
        meta: { resetScrollbar: true }
    },
    {
        path: '/projects',
        name: 'project.index',
        component: PageProjects,
        props: true,
        meta: { title: i18n.t('pages.projects'), resetScrollbar: true }
    },
    {
        path: '/folders',
        name: 'folder.index',
        component: PageFolders,
        props: true,
        meta: { title: i18n.t('pages.folders'), resetScrollbar: true }
    },
    {
        path: '/folders/:id/:slug?',
        name: 'folder.view',
        component: PageFolder,
        props: true,
        meta: { title: i18n.t('pages.folder'), resetScrollbar: true }
    },
]
